import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { AuthoritySection } from '../components/AuthoritySection';
import { ProblemSection } from '../components/ProblemSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { WhatIncludedSection } from '../components/WhatIncludedSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { FinalExpensesSection } from '../components/FinalExpensesSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { NotificationPopups } from '../components/NotificationPopups';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen flex flex-col font-body" data-id="element-192">
      <main className="flex-grow" data-id="element-193">
        <HeroSection data-id="element-194" />
        <AuthoritySection data-id="element-195" />
        <ProblemSection data-id="element-196" />
        <HowItWorksSection data-id="element-197" />
        <WhatIncludedSection data-id="element-198" />
        <ForWhoSection data-id="element-199" />
        <FinalExpensesSection data-id="element-200" />
        <FAQSection data-id="element-201" />
        <FinalCTASection data-id="element-202" />
      </main>
      <Footer data-id="element-203" />
      <NotificationPopups data-id="element-204" />
    </div>;
}